<ng-container *ngIf="facade.logoDetails$ | ngrxPush as content">
  <idp-logo
    *ngIf="content.logo"
    [content]="content || emptyDetails"
    [isBusiness]="isBusiness"
    [mobileDarkSiteLogo]="
      (facade.isDarkSiteEnabled$ | ngrxPush) ?? {
        isEnabled: '',
        level: '',
        enableBlackTheme: ''
      }
    "
    [vacationHeader]="vacationHeader"
    (openPopup)="openPopup($event)"
    (analyticsEvent)="analyticsEventTracking($event)"
  ></idp-logo>
</ng-container>
